import BreadProduct from 'models/BreadProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BreadPackage from './BreadPackage'

const productOptions = {
  packagingInfo: <BreadPackage />,
  productTitle: 'Whole Wheat Bread',
  model: BreadProduct,
  validCategories: ['16'],
  validSubCategories: ['001'],
}

const Bread = () => <ProductForm product={productOptions} />

export default Bread

export const getBreadPackage = newProduct => {
  const newBreadPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Whole Grain Bread',
    BreadType: newProduct.BreadType,
    BreadSize: newProduct.BreadSize,
  }
  return newBreadPackage
}
export const updateBreadPackage = newProduct => {
  const newBreadPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Whole Grain Bread',
    BreadType: newProduct.BreadType,
    BreadSize: newProduct.BreadSize,
  }
  return newBreadPackage
}
